import React from "react";

const ExpenseSummary = () => {
  return (
    <div className="dashboard-card">
      <div className="card-header">
        <h3 className="card-title">Expense Summary</h3>
      </div>

      <div className="card-body">
        <p>Pending Claims : 18</p>
        <p>Approved : 124</p>
        <p>Rejected : 6</p>
        <p>Reimbursements : ₹1,82,000</p>
      </div>
    </div>
  );
};

export default ExpenseSummary;